// @flow
import * as React from 'react';

import customHistory from 'common/middleware/history';
import useResolvedClientId from 'common/hooks/useResolvedClientId';

import {
    AuthProvider as UniversalAuthProvider,
    CrossTabLogoutSync
} from '@locus-taxy/auth-react';

import AuthStateHandler from './AuthStateHandler';

import EnvConfig from 'config';

const HANDLE_CALLBACK = (fromLocation?: Location | { pathname: string }) => {
    const url: string = customHistory.createHref(
        fromLocation || { pathname: '/' }
    );
    /**
     * #HACK because we need to do `replace` twice (router + window.history),
     * because we use the hash router, which
     * does't redirect correctly from redirect URLs with /?code=
     * */
    window.history.replaceState({}, '', `/${url}`);
    customHistory.replace(fromLocation || { pathname: '/' });
};

const REDIRECT_CALLBACK = appState => {
    const { currentLocation } = appState;
    const fromLocation = currentLocation?.state?.fromLocation;
    HANDLE_CALLBACK(fromLocation);
};

type Props = {
    children: React.Node
};

const AuthProvider = ({ children }: Props): React.Node => {
    const redirectUri = `${window.location.origin}/#/login/callback`;
    const onRedirectCallback = REDIRECT_CALLBACK;
    const { localResolvedClientId } = useResolvedClientId();

    return (
        <UniversalAuthProvider
            domain={EnvConfig.auth.domain}
            clientId={EnvConfig.auth.client_id}
            audience={EnvConfig.auth.audience}
            apiEndPoint={EnvConfig.platformEndPoint}
            loginHint={`?${localResolvedClientId}`}
            redirectUri={redirectUri}
            onRedirectCallback={onRedirectCallback}
            locusClientId={localResolvedClientId}
        >
            <CrossTabLogoutSync />
            <AuthStateHandler>{children}</AuthStateHandler>
        </UniversalAuthProvider>
    );
};

export default AuthProvider;
